import { MetaView, useTable, withTable } from '@oscar/table';
import { Space } from '@oscar/theme';
import { FilterTable, PageHeader } from 'common/components';
import { APIS } from 'common/constants/endpoints';
import { useAuth } from 'features/auth';
import { default as React } from 'react';
import { columnsHomeTab, transformRequest, transformResponse } from '../utils';
import Statistic from './components/Statistic';
import { BubbleComponent } from './components/Bubble';
import './style.scss';
import { Typography } from 'antd';

const { Title } = Typography;

export type HomeTabProps = {
  currentRole?: string[];
};

const Table = withTable<HomeTabProps>({
  name: 'requests',
  keyField: 'id',
  mode: 'REMOTE',
  request: {
    name: 'requests',
    url: APIS.REQUESTS,
    method: 'POST',
    transformRequest: transformRequest,
    transformResponse: transformResponse,
    nextData: props => {
      return props;
    },
  },
  columns: columnsHomeTab,
});

const TableRequest = () => {
  const [table] = useTable();
  const [auth] = useAuth();
  if (auth.getUserRoles()?.length === 0) {
    return null;
  }
  return (
    <div className="request-list">
      <PageHeader
        title={`Hello ${auth.getUserInformation()?.fullName}`}
        subtitle="Here are the requests pending your actions"
      />
      <Statistic
        onClick={status => {
          table?.methods?.fetchData({
            filters: {
              status: status.toString(),
              typeOfWork: 0,
              keyWord: '',
            },
          });
        }}
        currentRole={auth.getUserRoles()}
      />
      <Title level={4}>Scaffold Requests</Title>
      <BubbleComponent />

      <div className="main-request-list">
        <MetaView table={table}>
          {(childProps: any) => (
            <FilterTable
              actionTable={childProps?.table}
              metadata={childProps?.metadata}
            />
          )}
        </MetaView>

        <Space size={[16, 16]} direction="vertical" className="space-table">
          <Table
            key="all-request"
            rowKey="id"
            table={table}
            currentRole={auth.getUserRoles()}
          />
        </Space>
      </div>
    </div>
  );
};

export default TableRequest;
